import { useEffect, useState } from 'react';
import { BUILD_ID } from '../../version';
import useLanguage from '../../hooks/useLanguage';
import useTheme from '../../hooks/useTheme';
import { checkWebsiteVersion, clearWebsiteReloadMarker, hasWebsiteUpdate, rememberWebsiteVersion } from '../../utils/websiteVersion';
import WebsiteVersionDialog from './WebsiteVersionDialog';
import XiaoyingLoading from './XiaoyingLoading';

export default function WebsiteVersionGate({ children }) {
  const { language } = useLanguage();
  useTheme();
  const [status, setStatus] = useState(BUILD_ID ? 'checking' : 'development');
  const [notice, setNotice] = useState(false);
  useEffect(() => {
    if (!BUILD_ID) return undefined;
    const controller = new AbortController();
    let active = true;
    const timeout = window.setTimeout(() => controller.abort(), 4000);
    checkWebsiteVersion({ signal: controller.signal }).then(result => {
      if (!active) return;
      window.clearTimeout(timeout);
      if (result !== 'reloading') clearWebsiteReloadMarker();
      setNotice(result === 'outdated' || (result === 'current' && hasWebsiteUpdate(BUILD_ID)));
      setStatus(result);
    });
    return () => { active = false; window.clearTimeout(timeout); controller.abort(); };
  }, []);

  if (status === 'checking' || status === 'reloading') {
    return <XiaoyingLoading label="正在打开小影" detail={status === 'reloading' ? '正在载入最新版本' : '正在准备创作空间'} />;
  }
  return <>
    {children}
    {notice && <WebsiteVersionDialog
      outdated={status === 'outdated'}
      english={language === 'en-US'}
      onClose={() => { if (status === 'current') rememberWebsiteVersion(BUILD_ID); setNotice(false); }}
    />}
  </>;
}
